import { Comments } from "../../../../components";
import { Button } from "../../../../shared";
import { Box, Divider, Dropdown, Menu, MenuButton, MenuItem, Typography } from "@mui/joy";
import { ChevronDown, ChevronRight, Save } from "lucide-react";

interface ITaskAction {
    taskName: string;
    onComplete: () => void;
    actionProgress?: any;
    isNextEligible?: boolean;
}
export default function TaskAction(props: ITaskAction) {
    const { taskName, onComplete, actionProgress, isNextEligible } = { ...props };

    const handleOnClose = () => {
        onComplete();
    };

    return (
        <Box>
            <Divider sx={{ mt: 2 }} inset="context" />
            <Box mt={2}>
                <Typography level={"body-sm"} sx={{ color: "text.primary", fontWeight: 600 }} gutterBottom>
                    Task Status
                </Typography>
                <Typography level={"body-md"} sx={{ color: "text.primary" }} gutterBottom>
                    Update the status to keep your team informed about the current progress.
                </Typography>
                <Box display={"flex"} gap={1}>
                    {/* <Button startDecorator={<Save size={18} />}>Save</Button> */}
                    <Button
                        endDecorator={<ChevronRight size={18} />}
                        variant={"soft"}
                        onClick={handleOnClose}
                        loading={actionProgress?.loading}
                        loadingPosition={"start"}
                        disabled={!isNextEligible}
                    >
                        Save & Continue to Next Task
                    </Button>
                    <Dropdown>
                        <MenuButton endDecorator={<ChevronDown size={16} />}>In Progress</MenuButton>
                        <Menu sx={{ zIndex: 1001 }}>
                            <MenuItem>In Progress</MenuItem>
                            <MenuItem>Pending</MenuItem>
                            <MenuItem>Complete</MenuItem>
                            <MenuItem>Cancelled</MenuItem>
                        </Menu>
                    </Dropdown>
                </Box>
            </Box>
            <Divider sx={{ mt: 2 }} inset="context" />
            <Box mt={2}>
                <Box flex={1} mb={1}>
                    <Typography level={"body-sm"} sx={{ color: "text.primary", fontWeight: 600 }} gutterBottom>
                        Comments
                    </Typography>
                    <Typography level={"body-md"} sx={{ color: "text.primary" }}>
                        Additional comments or any other details you like to add about this project
                    </Typography>
                </Box>

                <Comments />
            </Box>
        </Box>
    );
}
